import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 6V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "14", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 10v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 17v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 14H9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 14H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 11-.88.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3.88 16.12 3 17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 17-.88-.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3.88 11.88 3 11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileCog";
const FileCog = memo(themed(Icon));
export {
  FileCog
};
//# sourceMappingURL=file-cog.js.map
